import { ReactElement, useContext } from "react";
import { TestResult, TestVersion } from "../../api";
import { Typography, Stack, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { AppContext } from "@cdv/jazz-ui";

export default function ResultCard({
  version,
  result,
}: {
  version: TestVersion;
  result: TestResult;
}): ReactElement {
  const navigate = useNavigate();
  const { getUrl } = useContext(AppContext);
  return (
    <>
      <Typography variant="h5" sx={{ textAlign: "center", fontSize: "20px" }}>
        {version.name} - vyhodnocení
      </Typography>
      <Stack sx={{ alignItems: "center", mt: "10px" }}>
        <img
          src={result?.image?.id ? `/obrazky/${result.image.id}` : ""}
          style={{ height: "100px" }}
        />
      </Stack>
      <Typography sx={{ textAlign: "center", mt: "10px", fontSize: "20px" }} variant="h5">
        {result.title}
      </Typography>
      <Typography sx={{ mt: "10px", color: "#00000099" }}>{result.description}</Typography>
      <Button
        variant="contained"
        color="inherit"
        size="large"
        fullWidth
        sx={{ mt: "10px" }}
        onClick={() => navigate("/info/help")}
      >
        Najít pomoc
      </Button>
    </>
  );
}
